import { useEffect, useRef } from "react"
import { StripeCache } from "../utils/stripeCache"

export function useStripeReturnDetection() {
  const hasCheckedRef = useRef(false)

  useEffect(() => {
    if (hasCheckedRef.current) return

    const urlParams = new URLSearchParams(window.location.search)
    const pathname = window.location.pathname

    const isStripeReturn =
      urlParams.has("session_id") ||
      urlParams.has("payment_intent") ||
      urlParams.has("setup_intent") ||
      urlParams.has("subscription_id") ||
      pathname.includes("/billing") ||
      pathname.includes("/subscription")

    if (isStripeReturn) {
      StripeCache.invalidateAfterBillingPortal()
    }

    hasCheckedRef.current = true

    const handleVisibilityChange = () => {
      if (document.visibilityState === "visible" && isStripeReturn) {
        StripeCache.invalidateAfterBillingPortal()
      }
    }

    document.addEventListener("visibilitychange", handleVisibilityChange)
    return () =>
      document.removeEventListener("visibilitychange", handleVisibilityChange)
  }, [])
}
